module.exports = __webpack_public_path__ + "img/shoufei.f368b242.png";